import { I18n } from 'src/modules/common/components/I18n/I18n';
import { RadioButton } from 'src/modules/common/components/Radio/RadioButton';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { Dispatch, SetStateAction } from 'react';

type Props = {
    setMethod: Dispatch<SetStateAction<boolean>>;
    isMethodA: boolean;
}

export const CalculationMethod = ({ setMethod, isMethodA }: Props) => (
    <div className="vss-calc-v100__methods">
        <RadioButton
            id="methodA"
            checked={isMethodA}
            onChange={() => {
                setMethod(true);
            }}
        >
            <I18n messageId={MESSAGES.methodA}/>
        </RadioButton>

        <RadioButton
            id="methodB"
            checked={!isMethodA}
            onChange={() => {
                setMethod(false);
            }}
        >
            <I18n messageId={MESSAGES.methodB}/>
        </RadioButton>
    </div>
);
